import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components';
import React from 'react';
import { useAppConfig } from '~/App/Api/AppConfig';

export interface SeeAllBonjoroPlansProps {
  className?: string;
}

const SeeAllBonjoroPlans = ({ className }: SeeAllBonjoroPlansProps) => {
  const { data: appConfig } = useAppConfig();
  const pricingPageUrl = appConfig?.bonjoroPricingPageUrl ?? '/pricing';

  return (
    <a href={pricingPageUrl} className={className}>
      <Button variant={ButtonVariant.Info}>See all Bonjoro Plans</Button>
    </a>
  );
};

export default SeeAllBonjoroPlans;
